__turbopack_context__.v({
  "input": "switch-module-scss-module__VprPuG__input",
  "label": "switch-module-scss-module__VprPuG__label",
  "marker": "switch-module-scss-module__VprPuG__marker",
  "root": "switch-module-scss-module__VprPuG__root",
  "root__active": "switch-module-scss-module__VprPuG__root__active",
  "root__disabled": "switch-module-scss-module__VprPuG__root__disabled",
  "wrap": "switch-module-scss-module__VprPuG__wrap",
});
